"use strict";var $export=require("./_export");$export($export.S,"Reflect",{ownKeys:require("./_own-keys")});